import { Component, Input } from "@angular/core";
import { ConfirmationModalComponent } from "../../../modals/confirmation-modal.component";
import { Subject } from "rxjs";
import { HotToastService } from "@ngneat/hot-toast";
import { JobsService } from "../../jobs.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-bulk-change-status",
  imports: [CommonModule, FormsModule, DropdownModule],
  templateUrl: "./bulk-change-status.component.html",
  styleUrls: ["./bulk-change-ownership-modal.component.scss"],
})
export class BulkChangeStatusComponent {
  loading: boolean = false;

  @Input() jobs: any[] = [];
  @Input() statuses: any;
  selectedNewStatus: any;

  public onClose: Subject<boolean>;

  public constructor(
    private toastr: HotToastService,
    private jobsService: JobsService,
    public modalService: BsModalService,
    public bsModalRef: BsModalRef,
  ) {}

  ngOnInit() {
    this.onClose = new Subject();
  }

  confirm() {
    this.bsModalRef.hide();
    setTimeout(() => {
      let initialState = {
        message: `These ${this.jobs.length} jobs statuses will be updated.<br/> \
                  If there are many jobs selected, this may take some time to complete.<br/> \
                  Continue?`,
        confirmButtonClass: "btn-primary",
      };
      let confirmationModal = this.modalService.show(
        ConfirmationModalComponent,
        { initialState },
      );
      confirmationModal.content.onClose.subscribe((res) => {
        if (res) {
          this.updateStatuses();
          this.onClose.next(true);
        }
      });
    }, 200);
  }

  cancel() {
    this.bsModalRef.hide();
    this.onClose.next(false);
  }

  updateStatuses() {
    const { value: status } = this.selectedNewStatus;
    const data = this.jobs.map((job) => ({ uuid: job.uuid, status }));
    this.loading = true;
    this.jobsService
      .updateStatuses(data)
      .then(() => {
        this.toastr.success("The jobs will be updated soon.");
        this.onClose.next(true);
      })
      .catch((err) => {
        this.toastr.error(err.message);
      })
      .finally(() => (this.loading = false));
  }
}
